import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const IdentifiersToolTip = () => (
    <CustomToolTip
        type="?"
        info={
            <>
                <p>
                    These are codes used by the music industry that uniquely identify publishers or publishing entities.
                </p>
                <p>If you do not have any of these identifiers, please leave them blank.</p>
            </>
        }
    />
)

export default IdentifiersToolTip
